import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { setPowerSystemCookie, getPowerSystemCookie } from '@/utils/auth'
import { getUrlKey } from '@/utils/index'
const Base64 = require('js-base64').Base64

NProgress.configure({ showSpinner: false })// NProgress Configuration

const judge = (to, next, hasCode) => {
  // 实时更新urlInfo(旧代码中有用到里边的数据)
  const powerToken = getPowerSystemCookie()
  if (powerToken) {
    const user = JSON.parse(powerToken)
    const newInfo = {
      userId: user.userInfo.userId,
      username: user.userInfo.username,
      systemCode: process.env.VUE_APP_SYSTEM_CODE,
      token: user.token
    }
    sessionStorage.setItem('urlInfo', JSON.stringify(newInfo))
    if (store.getters.userId === '') {
      store.dispatch('GetUserInfo').then(() => { // 拉取user_info
        store.dispatch('GenerateRoutes', {}).then(() => { // 根据roles权限生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          if (hasCode) {
            router.push({ path: '/' })
          } else {
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          }
        })
      }).catch((err) => {
        store.dispatch('LogOut').then(() => {
          Message.error(err)
          NProgress.done()
          window.close()
        })
      })
    } else {
      next()
    }
  } else {
    store.dispatch('LogOut').then(() => {
      NProgress.done()
      window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`
    })
  }
}
router.beforeEach((to, from, next) => {
  console.log(666, window.location.href, to)
  NProgress.start() // start progress bar
  if (window.location.href.indexOf('?code=') !== -1) {
    // 需特殊处理来自钉钉管理台进入时，code的处理。
    // 将Power-Admin-Info存入.suntekcorps.com cookie中，与权限系统一致
    if (window.location.href.indexOf('&type') !== -1) {
      console.log(999, window.location.href, to)
      const urlInfo = JSON.parse(Base64.decode(getUrlKey('code')))
      const urlInfoToken = JSON.parse(Base64.decode(urlInfo.token.split('.')[1]))
      const json = {
        token: urlInfo.token,
        userInfo: {
          userId: urlInfo.userId,
          username: urlInfoToken.username
        }
      }
      // Message.info(urlInfo)
      setPowerSystemCookie(JSON.stringify(json))
      // store.dispatch('LoginByUsername').then(res => {
      //   if (to.path === '/index') {
      //     if (to.query.type === 'isDing') {
      //       router.push('/index?test=abc')
      //     } else {
      //       next()
      //     }
      //     // window.location.reload()
      //   } else {
      //     router.push({ path: to.path })
      //   }
      //   // router.push({ path: to.path }).catch(e => {})
      // }).catch(err => {
      //   Message.error(err)
      // })

      // 新加
      const newInfo = {
        userId: urlInfo.userId,
        username: urlInfoToken.username,
        systemCode: process.env.VUE_APP_SYSTEM_CODE,
        token: urlInfo.token
      }

      sessionStorage.setItem('urlInfo', JSON.stringify(newInfo))
      store.dispatch('GetUserInfo').then(() => { // 拉取user_info
        store.dispatch('GenerateRoutes', {}).then(() => { // 根据roles权限生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          // router.push({ path: to.path })
          if (to.path === '/index') {
            if (to.query.test) {
              next()
            } else {
              next('/index?test=abc')
            }
          } else {
            router.push({ path: to.path })
          }
        })
      }).catch((err) => {
        store.dispatch('LogOut').then(() => {
          Message.error(err)
          NProgress.done()
          window.close()
        })
      })
    } else {
      const NProgressInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
      if (NProgressInfo) {
        judge(to, next, true)
      } else {
        store.dispatch('LoginByUsername').then(res => {
        // router.push({ path: '/' })
          if (to.path === '/index') {
            // next()
            router.push({ path: '/' })
          } else {
            router.push({ path: to.path }).catch(e => {})
          }
        }).catch(err => {
          Message.error(err)
        })
      }
    }
  } else if (getPowerSystemCookie()) {
    const NProgressInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
    if (NProgressInfo) {
      judge(to, next)
    } else {
      // 取权限系统登陆时存的顶级域名cookie,组装成code格式
      const powerToken = getPowerSystemCookie()
      const user = JSON.parse(powerToken)
      const newInfo = {
        userId: user.userInfo.userId,
        username: user.userInfo.username,
        systemCode: process.env.VUE_APP_SYSTEM_CODE,
        token: user.token
      }
      sessionStorage.setItem('urlInfo', JSON.stringify(newInfo))
      store.dispatch('GetUserInfo').then(() => { // 拉取user_info
        store.dispatch('GenerateRoutes', {}).then(() => { // 根据roles权限生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        })
      }).catch((err) => {
        store.dispatch('LogOut').then(() => {
          Message.error(err)
          NProgress.done()
          window.close()
        })
      })
    }
  } else {
    window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
